import * as angular from 'angular';
import {IController} from "angular";

export class FulfillmentStepItemSettingsPanelComponent implements IController {
  settings: any;
  onSettingsChange: Function;

  public queryString: string;
  public sections: any;


  /* @ngInject */
  constructor(private $mdPanel) {
  }

  $onInit() {
    this.sections = angular.copy(this.settings)
  }


  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          sections: this.sections,
          queryString: this.queryString,
          parentScope: this
        },

        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: FulfillmentStepItemSettingsCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: require('./panel-template.html').default,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason) => {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig, parentScope) {
    parentScope.onSettingsChange({
      settings: settingsConfig.sections
    })
  }

}

class FulfillmentStepItemSettingsCtrl implements IController {

  public settings: any;
  private settingsConfig: any;
  private queryString: string;


  constructor(private mdPanelRef, private $filter) {

  }

  $onInit() {

    this.settingsConfig = {
      sections: this.mdPanelRef.config.locals.data.sections
    };

    this.settings = this.settingsConfig.sections;
    this.queryString = this.mdPanelRef.config.locals.data.queryString
  }

  onSectionChanged(key, value) {
    this.settingsConfig.sections[key] = value;
    this.mdPanelRef.config.locals.data.parentScope.onSettingsChange({settings: this.settingsConfig.sections})
  }


  cancel() {
    this.mdPanelRef.close();
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepItemSettingsPanel', {
    bindings: {
      settings: '<',
      onSettingsChange: '&'
    },
    template: require('./fulfillment-step-item-settings-panel.html').default,
    controller: FulfillmentStepItemSettingsPanelComponent
  });
